export default "__VITE_ASSET__B8oF2HZl__"